import { Box, } from "@chakra-ui/react";
import { PaymentsPageHeader, } from "../../components/features/PaymentsPage";
import { PaymentsList, } from "../../components/features/PaymentsList";
import { Outlet, } from "react-router-dom";

export function PaymentsPage() {
  return (
    <div>
      <Box py={2}>
        <PaymentsPageHeader />
      </Box>
      <Box py={2}>
        <PaymentsList />
        <Outlet />
      </Box>
    </div>
  );
}
